<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康管理护士工作站</el-breadcrumb-item>
        <el-breadcrumb-item>线上健康管理</el-breadcrumb-item>
        <el-breadcrumb-item>健康管理方案</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>

    <el-button-group>
      <el-button class="healthButton" @click="click(0)">健康动态数据</el-button>
      <el-button class="healthButton" @click="click(1)">数字档案完成度</el-button>
      <el-button class="healthButton healthActive" style="background-color: #fff" @click="click(2)">健康管理方案</el-button>
      <el-button class="healthButton" @click="click(3)">认知行为治疗状态</el-button>
      <el-button class="healthButton" @click="click(4)">消息推送</el-button>
    </el-button-group>
    <div class="card-row" style="margin-bottom: 20px">
      <div class="card card01">
        <div class="card-row" style="font-size: 20px; font-weight: bold; margin-bottom: 2vh">
          {{ info.name }}
        </div>
        <div class="card03" style="font-size: 14px">
          <div>性别：{{ info.sex === 1 ? '男' : info.sex === 2 ? '女' : '未填写' }}</div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card03" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>身高|体重：{{ info.height ? info.height : ' ' }}cm/{{ info.weight ? info.weight : ' ' }}kg</div>
          <div>身份证号：{{ info.idCard }}</div>
        </div>
      </div>
    </div>

    <!-- <avue-crud :option="option" :data="data" ref="crud" v-model="form" :permission="permissionList" :page.sync="page" @on-load="onLoad" :header-cell-class-name="headerCellClassName">
      <template slot="menuLeft"></template>
      <template slot="menuRight">
        <el-button size="mini" type="primary" plain @click="checkRecord">查询记录</el-button>
        <el-button size="mini" type="primary" @click="archive" style="margin-left: 8px">存档</el-button>
      </template>
      <template slot-scope="scope" slot="drug">
        <el-button type="text" size="small" @click.native="toDrug(scope.row)">查看药品</el-button>
      </template>
      <template slot-scope="scope" slot="motion">
        <el-button type="text" size="small" @click.native="toMotion(scope.row)">查看运动处方</el-button>
      </template>
    </avue-crud> -->

    <div style="display: flex; justify-content: flex-start; margin-bottom: 10px">
      <el-button type="success" @click="createDoctorOrder(reportType)">
        {{ reportType == 1 ? '生成长期医嘱单' : reportType == 2 ? '生成临时医嘱单' : '' }}
      </el-button>
    </div>

    <!-- <div class="yizhudan" style="margin-top:30px;">
      <el-button-group>
        <el-button  size="medium" @click="tapChange(1)">长期医嘱单</el-button>
        <el-button  size="medium" @click="tapChange(2)">临时医嘱单</el-button>
      </el-button-group>
    </div> -->

    <div style="display: flex">
      <div class="tap">
        <div :class="reportType === 1 ? 'active' : ''" @click="tapChange(1)">长期医嘱单</div>
        <div :class="reportType === 2 ? 'active' : ''" @click="tapChange(2)">临时医嘱单</div>
      </div>

      <div id="pdf-content" v-if="reportType === 1" class="prescription-container">
        <h1>大白数智家医健康管理长期医嘱单</h1>

        <table class="info-table" style="text-align: center">
          <tr>
            <td style="width: 25mm">姓名</td>
            <td style="width: 30mm">
              <input style="width: 35mm" v-model="doctorOrder.name" />
            </td>
            <td style="width: 25mm">健康档案号</td>
            <td style="width: 35mm">
              <input style="width: 30mm" v-model="doctorOrder.number" readonly />
            </td>
          </tr>
          <tr>
            <td style="width: 25mm">下达日期</td>
            <td style="width: 35mm">
              <el-date-picker v-model="doctorOrder.orderDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            </td>
            <td style="width: 20mm">家庭护理</td>
            <td>
              <input style="width: 25mm" v-model="doctorOrder.doctor" />
            </td>
          </tr>
        </table>

        <div class="model" style="">
          <div class="title">健康监测</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">检测来源</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <tr style="text-align: center">
              <td>血压、心率测量</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[0].measure" />
              </td>
              <td>
                <!-- <input
                  style="width: 20mm"
                  v-model="doctorOrderDetail[0].frequency"
                /> -->
                <el-select v-model="doctorOrderDetail[0].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[0].realTime" />
              </td>
              <td>
                <span @click="confirm(0)">
                  {{ doctorOrderDetail[0].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[0].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>血糖检测</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[1].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[1].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[1].realTime" />
              </td>
              <td>
                <span @click="confirm(1)">
                  {{ doctorOrderDetail[1].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[1].excutor" />
              </td>
            </tr>

            <tr style="text-align: center">
              <td>体重及体成分测量</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[2].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[2].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[2].realTime" />
              </td>
              <td>
                <span @click="confirm(2)">
                  {{ doctorOrderDetail[2].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[2].excutor" />
              </td>
            </tr>

            <tr style="text-align: center" v-for="(item, index) in tableData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="healthConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addRow">+</div>
            <div v-if="tableData.length > 0" @click="deleteRow(index)">-</div>
          </div>
        </div>

        <div class="model" style="">
          <div class="title">非药物治疗</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">目标</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <tr style="text-align: center">
              <td>饮食计划</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[3].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[3].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[3].realTime" />
              </td>
              <td>
                <span @click="confirm(3)">
                  {{ doctorOrderDetail[3].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[3].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>有氧运动</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[4].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[4].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[4].realTime" />
              </td>
              <td>
                <span @click="confirm(4)">
                  {{ doctorOrderDetail[4].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[4].excutor" />
              </td>
            </tr>

            <tr style="text-align: center">
              <td>力量训练</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[5].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[5].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[5].realTime" />
              </td>
              <td>
                <span @click="confirm(5)">
                  {{ doctorOrderDetail[5].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[5].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>睡眠管理</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[6].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[6].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[6].realTime" />
              </td>
              <td>
                <span @click="confirm(6)">
                  {{ doctorOrderDetail[6].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[6].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in noMedicineData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="noMedicineConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addNoMedicine">+</div>
            <div v-if="noMedicineData.length > 0" @click="deleteNoMedicine(index)">-</div>
          </div>
        </div>

        <div class="model" style="">
          <div class="title">药物治疗</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">用法 (剂量+途径)</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
            <tr style="text-align: center">
              <td>药物名称</td>
              <td>
                <input style="width: 40mm; border-bottom: 1px solid #222" v-model="doctorOrderDetail[7].measure" />
                <!-- mg(口服) -->
              </td>
              <td>
                <!-- <el-select v-model="doctorOrderDetail[7].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select> -->
                <input style="width: 20mm" v-model="doctorOrderDetail[8].frequency" />
              </td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[7].realTime" />
              </td>
              <td>
                <span @click="confirm(7)">
                  {{ doctorOrderDetail[7].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[7].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>药物名称</td>
              <td>
                <input style="width: 40mm; border-bottom: 1px solid #222" v-model="doctorOrderDetail[8].measure" />
                <!-- mg(皮下注射) -->
              </td>
              <td>
                <!-- <el-select v-model="doctorOrderDetail[8].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select> -->
                <input style="width: 20mm" v-model="doctorOrderDetail[8].frequency" />
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[8].realTime" />
              </td>
              <td>
                <span @click="confirm(8)">
                  {{ doctorOrderDetail[8].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[8].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in medicineData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="medicineConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addMedicine">+</div>
            <div v-if="medicineData.length > 0" @click="deleteMedicine(index)">-</div>
          </div>
        </div>

        <div class="model" style="">
          <div class="title">健康管理</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">目标</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
            <tr style="text-align: center">
              <td>健康数据上报</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[9].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[9].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[9].realTime" />
              </td>
              <td>
                <span @click="confirm(9)">
                  {{ doctorOrderDetail[9].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[9].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>健康知识学习</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[10].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[10].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[10].realTime" />
              </td>
              <td>
                <span @click="confirm(10)">
                  {{ doctorOrderDetail[10].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[10].excutor" />
              </td>
            </tr>

            <tr style="text-align: center">
              <td>线上随访</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[11].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[11].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[11].realTime" />
              </td>
              <td>
                <span @click="confirm(11)">
                  {{ doctorOrderDetail[11].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[11].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in manageData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="manageConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addManage">+</div>
            <div v-if="manageData.length > 0" @click="deleteManage(index)">-</div>
          </div>
        </div>

        <div class="model" style="">
          <div class="title">其他</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">用法 (剂量+途径)</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
            <tr style="text-align: center">
              <td>
                <input style="width: 25mm" v-model="doctorOrderDetail[12].other" />
              </td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[12].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[12].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[12].realTime" />
              </td>
              <td>
                <span @click="confirm(12)">
                  {{ doctorOrderDetail[12].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[12].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in otherData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="otherConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addOther">+</div>
            <div v-if="otherData.length > 0" @click="deleteOther(index)">-</div>
          </div>
        </div>

        <div class="signature">
          <div>总确认： 本人已清晰理解以上所有长期医嘱内容，并承诺遵照执行。</div>
          <div class="date">
            <div>
              执行人签名：
              <input style="width: 20mm; border-bottom: 1px solid #222" v-model="info.userName" />
            </div>
            <div>
              日期：
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.year" />
              年
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.mouth" />
              月
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.day" />
              日
            </div>
          </div>
        </div>
      </div>

      <div id="pdf-content-sort" v-if="reportType === 2" class="prescription-container" style="height: 286mm">
        <h1>大白数智家医健康管理临时医嘱单</h1>

        <table class="info-table" style="text-align: center">
          <tr>
            <td style="width: 25mm">姓名</td>
            <td style="width: 30mm">
              <input style="width: 35mm" v-model="doctorOrder.name" />
            </td>
            <td style="width: 25mm">健康档案号</td>
            <td style="width: 35mm">
              <input style="width: 30mm" v-model="doctorOrder.number" readonly />
            </td>
          </tr>
          <tr>
            <td style="width: 25mm">下达日期</td>
            <td style="width: 35mm">
              <el-date-picker v-model="doctorOrder.orderDate" type="date" placeholder="选择日期"></el-date-picker>
            </td>
            <td style="width: 20mm">家庭护理</td>
            <td>
              <input style="width: 25mm" v-model="doctorOrder.doctor" />
            </td>
          </tr>
        </table>

        <div class="model" style="">
          <h2>生命体征监测</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 18mm">具体时间</td>
              <td style="width: 19mm">下达日期</td>
              <td style="width: 19mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>

            <tr style="text-align: center">
              <td>体温监测</td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[0].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[0].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[0].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[0].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[0].stopTime" />
              </td>
              <td>
                <span @click="confirm(0)">
                  {{ doctorOrderDetail[0].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[0].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <div class="model" style="">
          <h2>非药物治疗</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 18mm">具体时间</td>
              <td style="width: 19mm">下达日期</td>
              <td style="width: 19mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>

            <tr style="text-align: center">
              <td>卧床休息</td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[1].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[1].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[1].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[1].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[1].stopTime" />
              </td>
              <td>
                <span @click="confirm(1)">
                  {{ doctorOrderDetail[1].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 10mm" v-model="doctorOrderDetail[1].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <div class="model" style="">
          <h2>药物治疗</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 20mm">具体时间</td>
              <td style="width: 20mm">下达日期</td>
              <td style="width: 20mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>

            <tr style="text-align: center">
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[2].medicine" />
              </td>
              <td>
                <input style="width: 10mm; border-bottom: 1px solid #222" v-model="doctorOrderDetail[2].measure" />
                mg(口服)
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[2].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[2].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[2].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[2].stopTime" />
              </td>
              <td>
                <span @click="confirm(2)">
                  {{ doctorOrderDetail[2].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[2].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[3].medicine" />
              </td>
              <td>
                <input style="width: 10mm; border-bottom: 1px solid #222" v-model="doctorOrderDetail[3].measure" />
                mg(口服)
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[3].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[3].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[3].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[3].stopTime" />
              </td>
              <td>
                <span @click="confirm(3)">
                  {{ doctorOrderDetail[3].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[3].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <div class="model" style="">
          <h2>健康管理</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 20mm">具体时间</td>
              <td style="width: 20mm">下达日期</td>
              <td style="width: 20mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>
            <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
            <tr style="text-align: center">
              <td>专项检查</td>
              <td>
                <input style="width: 25mm" v-model="doctorOrderDetail[4].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[4].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[4].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[4].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[4].stopTime" />
              </td>
              <td>
                <span @click="confirm(4)">
                  {{ doctorOrderDetail[4].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[4].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <div class="model" style="">
          <h2>其他</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 20mm">具体时间</td>
              <td style="width: 20mm">下达日期</td>
              <td style="width: 20mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>

            <tr style="text-align: center">
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[5].medicine" />
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[5].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[5].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[5].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[5].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[5].stopTime" />
              </td>
              <td>
                <span @click="confirm(5)">
                  {{ doctorOrderDetail[5].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[5].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <!-- 签名 -->
        <div class="signature">
          <!-- <p>运动处方师: {{ formData.doctor }}</p> -->
          <div>总确认： 本人已清晰理解以上所有临时医嘱内容，并承诺遵照执行。</div>
          <div class="date">
            <div>
              执行人签名：
              <input style="width: 20mm; border-bottom: 1px solid #222" v-model="info.sortUserName" />
            </div>
            <div>
              日期：
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.sortYear" />
              年
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.sortMouth" />
              月
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.sortDay" />
              日
            </div>
          </div>

          <div class="declare">
            <div class="title">重要声明：</div>
            <div>
              1. 请严格遵守医嘱内容，如有任何不适或疑问，请立即通过APP联系您的医疗团队。
              <br />
              2. 本医嘱单不能替代执业医师的面对面诊疗。如出现急重症，请立即前往最近医院急诊。
            </div>
          </div>
        </div>
      </div>

      <div id="pdf-content" v-if="reportType === 3" class="prescription-container">
        <h1>大白数智家医健康管理长期医嘱单</h1>

        <table class="info-table" style="text-align: center">
          <tr>
            <td style="width: 25mm">姓名</td>
            <td style="width: 30mm">
              <input style="width: 35mm" v-model="doctorOrder.name" />
            </td>
            <td style="width: 25mm">健康档案号</td>
            <td style="width: 35mm">
              <input style="width: 30mm" v-model="doctorOrder.number" readonly />
            </td>
          </tr>
          <tr>
            <td style="width: 25mm">下达日期</td>
            <td style="width: 35mm">
              <el-date-picker v-model="doctorOrder.orderDate" type="datetime" placeholder="选择日期"></el-date-picker>
            </td>
            <td style="width: 20mm">家庭护理</td>
            <td>
              <input style="width: 25mm" v-model="doctorOrder.doctor" />
            </td>
          </tr>
        </table>

        <div class="model" style="">
          <div class="title">生命体征监测</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">用法 (剂量+途径)</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <tr style="text-align: center">
              <td>血压、心率测量</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[0].measure" />
              </td>
              <td>
                <!-- <input
                  style="width: 20mm"
                  v-model="doctorOrderDetail[0].frequency"
                /> -->
                <el-select v-model="doctorOrderDetail[0].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[0].realTime" />
              </td>
              <td>
                <span @click="confirm(0)">
                  {{ doctorOrderDetail[0].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[0].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>血糖检测</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[1].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[1].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[1].realTime" />
              </td>
              <td>
                <span @click="confirm(1)">
                  {{ doctorOrderDetail[1].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[1].excutor" />
              </td>
            </tr>

            <tr style="text-align: center">
              <td>体重及体成分测量</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[2].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[2].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[2].realTime" />
              </td>
              <td>
                <span @click="confirm(2)">
                  {{ doctorOrderDetail[2].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[2].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in tableData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="healthConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addRow">+</div>
            <div v-if="tableData.length > 0" @click="deleteRow(index)">-</div>
          </div>
        </div>

        <div class="model" style="">
          <div class="title">非药物治疗</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">用法 (剂量+途径)</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <tr style="text-align: center">
              <td>饮食计划</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[3].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[3].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[3].realTime" />
              </td>
              <td>
                <span @click="confirm(3)">
                  {{ doctorOrderDetail[3].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[3].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>有氧运动</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[4].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[4].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[4].realTime" />
              </td>
              <td>
                <span @click="confirm(4)">
                  {{ doctorOrderDetail[4].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[4].excutor" />
              </td>
            </tr>

            <tr style="text-align: center">
              <td>力量训练</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[5].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[5].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[5].realTime" />
              </td>
              <td>
                <span @click="confirm(5)">
                  {{ doctorOrderDetail[5].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[5].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>睡眠管理</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[6].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[6].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[6].realTime" />
              </td>
              <td>
                <span @click="confirm(6)">
                  {{ doctorOrderDetail[6].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[6].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in noMedicineData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="noMedicineConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addNoMedicine">+</div>
            <div v-if="noMedicineData.length > 0" @click="deleteNoMedicine(index)">-</div>
          </div>
        </div>

        <div class="model" style="">
          <div class="title">药物治疗</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">用法 (剂量+途径)</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
            <tr style="text-align: center">
              <td>药物名称</td>
              <td>
                <input style="width: 40mm; border-bottom: 1px solid #222" v-model="doctorOrderDetail[7].measure" />
                mg(口服)
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[7].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[7].realTime" />
              </td>
              <td>
                <span @click="confirm(7)">
                  {{ doctorOrderDetail[7].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[7].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>药物名称</td>
              <td>
                <input style="width: 20mm; border-bottom: 1px solid #222" v-model="doctorOrderDetail[8].measure" />
                mg(皮下注射)
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[8].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[8].realTime" />
              </td>
              <td>
                <span @click="confirm(8)">
                  {{ doctorOrderDetail[8].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[8].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in medicineData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="medicineConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addMedicine">+</div>
            <div v-if="medicineData.length > 0" @click="deleteMedicine(index)">-</div>
          </div>
        </div>

        <div class="model" style="">
          <h2>健康管理</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">用法 (剂量+途径)</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
            <tr style="text-align: center">
              <td>健康数据上报</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[9].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[9].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[9].realTime" />
              </td>
              <td>
                <span @click="confirm(9)">
                  {{ doctorOrderDetail[9].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[9].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>健康知识学习</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[10].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[10].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[10].realTime" />
              </td>
              <td>
                <span @click="confirm(10)">
                  {{ doctorOrderDetail[10].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[10].excutor" />
              </td>
            </tr>

            <tr style="text-align: center">
              <td>线上随访</td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[11].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[11].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[11].realTime" />
              </td>
              <td>
                <span @click="confirm(11)">
                  {{ doctorOrderDetail[11].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[11].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in manageData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="manageConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addManage">+</div>
            <div v-if="manageData.length > 0" @click="deleteManage(index)">-</div>
          </div>
        </div>

        <div class="model" style="">
          <div class="title">其他</div>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 30mm">内容</td>
              <td style="width: 45mm">用法 (剂量+途径)</td>
              <td style="width: 25mm">执行频次</td>
              <td style="width: 30mm">具体时间</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 10mm">执行人签名</td>
            </tr>
            <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
            <tr style="text-align: center">
              <td>
                <input style="width: 25mm" v-model="doctorOrderDetail[12].other" />
              </td>
              <td>
                <input style="width: 40mm" v-model="doctorOrderDetail[12].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[12].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[12].realTime" />
              </td>
              <td>
                <span @click="confirm(12)">
                  {{ doctorOrderDetail[12].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[12].excutor" />
              </td>
            </tr>
            <tr style="text-align: center" v-for="(item, index) in otherData" :key="item.id">
              <td><input style="width: 40mm" v-model="item.content" /></td>
              <td>
                <input style="width: 40mm" v-model="item.source" />
              </td>
              <td>
                <el-select v-model="item.time" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 30mm" v-model="item.realTime" />
              </td>
              <td>
                <span @click="otherConfirm(index)">
                  {{ item.confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="item.name" />
              </td>
            </tr>
          </table>
          <div class="healthAdd">
            <div @click="addOther">+</div>
            <div v-if="otherData.length > 0" @click="deleteOther(index)">-</div>
          </div>
        </div>

        <div class="signature">
          <div>总确认： 本人已清晰理解以上所有长期医嘱内容，并承诺遵照执行。</div>
          <div class="date">
            <div>
              执行人签名：
              <input style="width: 20mm; border-bottom: 1px solid #222" v-model="info.userName" />
            </div>
            <div>
              日期：
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.year" />
              年
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.mouth" />
              月
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.day" />
              日
            </div>
          </div>
        </div>
      </div>

      <div id="pdf-content-sort" v-if="reportType === 4" class="prescription-container" style="height: 286mm">
        <h1>大白数智家医健康管理临时医嘱单</h1>

        <table class="info-table" style="text-align: center">
          <tr>
            <td style="width: 25mm">姓名</td>
            <td style="width: 30mm">
              <input style="width: 35mm" v-model="doctorOrder.name" />
            </td>
            <td style="width: 25mm">健康档案号</td>
            <td style="width: 35mm">
              <input style="width: 30mm" v-model="doctorOrder.number" readonly />
            </td>
          </tr>
          <tr>
            <td style="width: 25mm">下达日期</td>
            <td style="width: 35mm">
              <el-date-picker v-model="doctorOrder.orderDate" type="date" placeholder="选择日期"></el-date-picker>
            </td>
            <td style="width: 20mm">家庭护理</td>
            <td>
              <input style="width: 25mm" v-model="doctorOrder.doctor" />
            </td>
          </tr>
        </table>

        <div class="model" style="">
          <h2>生命体征监测</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 18mm">具体时间</td>
              <td style="width: 19mm">下达日期</td>
              <td style="width: 19mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>

            <tr style="text-align: center">
              <td>体温监测</td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[0].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[0].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[0].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[0].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[0].stopTime" />
              </td>
              <td>
                <span @click="confirm(0)">
                  {{ doctorOrderDetail[0].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[0].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <div class="model" style="">
          <h2>非药物治疗</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 18mm">具体时间</td>
              <td style="width: 19mm">下达日期</td>
              <td style="width: 19mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>

            <tr style="text-align: center">
              <td>卧床休息</td>
              <td>
                <input style="width: 30mm" v-model="doctorOrderDetail[1].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[1].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[1].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[1].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[1].stopTime" />
              </td>
              <td>
                <span @click="confirm(1)">
                  {{ doctorOrderDetail[1].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 10mm" v-model="doctorOrderDetail[1].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <div class="model" style="">
          <h2>药物治疗</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 20mm">具体时间</td>
              <td style="width: 20mm">下达日期</td>
              <td style="width: 20mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>

            <tr style="text-align: center">
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[2].medicine" />
              </td>
              <td>
                <input style="width: 10mm; border-bottom: 1px solid #222" v-model="doctorOrderDetail[2].measure" />
                mg(口服)
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[2].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[2].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[2].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[2].stopTime" />
              </td>
              <td>
                <span @click="confirm(2)">
                  {{ doctorOrderDetail[2].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[2].excutor" />
              </td>
            </tr>
            <tr style="text-align: center">
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[3].medicine" />
              </td>
              <td>
                <input style="width: 10mm; border-bottom: 1px solid #222" v-model="doctorOrderDetail[3].measure" />
                mg(口服)
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[3].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[3].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[3].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[3].stopTime" />
              </td>
              <td>
                <span @click="confirm(3)">
                  {{ doctorOrderDetail[3].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[3].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <div class="model" style="">
          <h2>健康管理</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 20mm">具体时间</td>
              <td style="width: 20mm">下达日期</td>
              <td style="width: 20mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>
            <!-- <tr>
                <td colspan="2" style="margin-left: 10mm">
                  <div style="display: flex">
                    <div style="margin-left: 5mm; width: 25mm; font-weight: bold">
                      健康筛查:
                    </div>
                  </div>
                </td>
              </tr> -->
            <tr style="text-align: center">
              <td>专项检查</td>
              <td>
                <input style="width: 25mm" v-model="doctorOrderDetail[4].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[4].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[4].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[4].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[4].stopTime" />
              </td>
              <td>
                <span @click="confirm(4)">
                  {{ doctorOrderDetail[4].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[4].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <div class="model" style="">
          <h2>其他</h2>
          <table class="data-table" style="">
            <tr style="text-align: center">
              <td style="width: 15mm">内容</td>
              <td style="width: 30mm">用法 (剂量+途径)</td>
              <td style="width: 32mm">执行频次</td>
              <td style="width: 20mm">具体时间</td>
              <td style="width: 20mm">下达日期</td>
              <td style="width: 20mm">停止日期</td>
              <td style="width: 10mm">确认(√)</td>
              <td style="width: 17mm">执行人签名</td>
            </tr>

            <tr style="text-align: center">
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[5].medicine" />
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[5].measure" />
              </td>
              <td>
                <el-select v-model="doctorOrderDetail[5].frequency" placeholder="请选择" size="mini">
                  <el-option v-for="item in rateSortOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                </el-select>
              </td>
              <td>
                <input style="width: 18mm" v-model="doctorOrderDetail[5].realTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[5].issueTime" />
              </td>
              <td>
                <input style="width: 19mm" v-model="doctorOrderDetail[5].stopTime" />
              </td>
              <td>
                <span @click="confirm(5)">
                  {{ doctorOrderDetail[5].confirm === 1 ? '☑' : '☐' }}
                </span>
              </td>
              <td>
                <input style="width: 15mm" v-model="doctorOrderDetail[5].excutor" />
              </td>
            </tr>
          </table>
        </div>

        <!-- 签名 -->
        <div class="signature">
          <!-- <p>运动处方师: {{ formData.doctor }}</p> -->
          <div>总确认： 本人已清晰理解以上所有临时医嘱内容，并承诺遵照执行。</div>
          <div class="date">
            <div>
              执行人签名：
              <input style="width: 20mm; border-bottom: 1px solid #222" v-model="info.sortUserName" />
            </div>
            <div>
              日期：
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.sortYear" />
              年
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.sortMouth" />
              月
              <input style="width: 10mm; border-bottom: 1px solid #222" v-model="info.sortDay" />
              日
            </div>
          </div>

          <div class="declare">
            <div class="title">重要声明：</div>
            <div>
              1. 请严格遵守医嘱内容，如有任何不适或疑问，请立即通过APP联系您的医疗团队。
              <br />
              2. 本医嘱单不能替代执业医师的面对面诊疗。如出现急重症，请立即前往最近医院急诊。
            </div>
          </div>
        </div>
      </div>

      <div class="pdf-options">
        <el-form label-width="120px">
          <el-form-item label="文件名称">
            <!-- <el-select v-model="pdfOptions.filename" placeholder="请选择">
              <el-option
                v-for="item in pdfOptions.options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select> -->
            <el-input v-model="pdfOptions.filename" placeholder="请输入文件名称" v-if="reportType === 1 || reportType === 3"></el-input>

            <el-input v-model="pdfOptions.filenameSort" placeholder="请输入文件名称" v-if="reportType === 2 || reportType === 4"></el-input>
          </el-form-item>
          <el-form-item label="页面方向">
            <el-radio-group v-model="pdfOptions.jsPDF.orientation">
              <el-radio label="portrait">纵向</el-radio>
              <!-- <el-radio label="landscape">横向</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="页面尺寸">
            <el-select v-model="pdfOptions.jsPDF.format" placeholder="请选择页面尺寸">
              <el-option label="A4 (210×297mm)" value="a4"></el-option>
              <!-- <el-option label="A5 (148×210mm)" value="a5"></el-option>
                <el-option label="Letter (216×279mm)" value="letter"></el-option>
                <el-option label="自定义" value="custom"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="边距(mm)" v-if="pdfOptions.jsPDF.format === 'custom'">
            <el-input-number v-model="pdfOptions.margin" :min="0" :max="50"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" style="float: right">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="generatePDF">生成PDF</el-button>
        </span>
      </div>
    </div>

    <el-drawer title="医嘱单记录" :visible.sync="drawer" :with-header="true" :modal="false" :size="'420px'">
      <div style="display: flex" v-for="(item, index) in doctorOrders" :key="index">
        <div class="clickDate" @click="clickDoctorOrder(item)">{{ item.orderId }} -{{ item.reportType === 1 ? '长期' : item.reportType === 2 ? '短期' : '' }} - {{ item.orderDate }}</div>
        <div class="clickDateDelete" @click="clickDateDelete(item)">删除</div>
      </div>
    </el-drawer>
  </basic-container>
</template>

<script>
import { getScheme, getUserJkDetail, savePcDoctorOrder, getDoctorOrder, getDoctorOrderDetail, removeDoctorOrder, getLongTermDoctorOrder } from '@/api/health/manage'
import { mapGetters } from 'vuex'
import html2pdf from 'html2pdf.js'

export default {
  data() {
    return {
      wxUserid: this.$route.query.wxUserId,
      wxUserId: this.$route.query.wxUserId,
      info: {},
      form: {},
      reportType: 1,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        column: [
          {
            label: '方案生成时间',
            prop: 'date'
            // search: true
          },
          {
            label: '药品推荐',
            prop: 'drug'
            // search: true
          },
          {
            label: '复查检查检验',
            prop: 'check'
            // search: true
          },
          {
            label: '临床营养方案',
            prop: 'nutrition',
            dicData: [
              { label: '尚未生成', value: 0 },
              { label: '已生成', value: 1 }
            ]
          },
          {
            label: '运动处方方案',
            prop: 'motion',
            dicData: [
              { label: '尚未生成', value: 0 },
              { label: '已生成', value: 1 }
            ]
          },
          {
            label: '睡眠改善方案',
            prop: 'heartRate'
          },
          {
            label: '情绪调节方案',
            prop: 'heartRate'
          }
        ]
      },
      data: [],
      doTime: '',
      doSortTime: '',
      lifeArr: {},
      nonDrug: {},
      drug: {},
      health: {},
      other: {},
      drawer: false,
      pdfOptions: {
        margin: 10,
        filename: '长期医嘱单.pdf',
        filenameSort: '临时医嘱单.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait'
        }
      },
      doctorOrder: {
        name: '',
        number: '',
        orderDate: null,
        doctor: ''
      },
      doctorOrders: [],
      doctorOrderLong_model: [
        {
          measure: '',
          frequency: '每日2次',
          realTime: '早7:00/ 晚19:00',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日2次',
          realTime: '空腹 / 晚餐后2小时',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日1次',
          realTime: '晨起后',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日3次',
          realTime: '早/中/晚餐',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每周5次',
          realTime: '每次30-45分钟',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每周2次',
          realTime: '每次20-30分钟',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日1次',
          realTime: '23:00前',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日3次',
          realTime: '早/中/晚餐',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每周5次',
          realTime: '每次30-45分钟',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日1次',
          realTime: '每晚21:00前',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每周2次',
          realTime: '',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每2周1次',
          realTime: '预约时间',
          confirm: 0,
          excutor: ''
        },
        {
          other: '',
          measure: '',
          frequency: '',
          realTime: '',
          confirm: 0,
          excutor: ''
        }
      ],
      doctorOrderSort_model: [
        {
          measure: '',
          frequency: '每4小时一次',
          realTime: '按需',
          issueTime: '',
          stopTime: '体温正常',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日1次',
          realTime: '短期',
          issueTime: '',
          stopTime: '症状缓解',
          confirm: 0,
          excutor: ''
        },
        {
          medicine: '',
          measure: '',
          frequency: '每日1次',
          realTime: '天数',
          day: '',
          issueTime: '',
          stopTime: '',
          confirm: 0,
          excutor: ''
        },
        {
          medicine: '',
          measure: '',
          frequency: '疼痛时服用',
          realTime: '疼痛时服用',
          issueTime: '',
          stopTime: '疼痛缓解',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '一次性',
          realTime: '',
          year: '',
          mouth: '',
          day: '',
          issueTime: '',
          stopTime: '',
          confirm: 0,
          excutor: ''
        },
        {
          medicine: '',
          measure: '',
          frequency: '每4小时一次',
          realTime: '按需',
          issueTime: '',
          stopTime: '',
          confirm: 0,
          excutor: ''
        }
      ],
      doctorOrderLong_recent: [],
      doctorOrderSort_recent: [],
      doctorOrderDetail: [
        {
          measure: '',
          frequency: '每日2次',
          realTime: '早7:00/ 晚19:00',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日2次',
          realTime: '空腹 / 晚餐后2小时',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日1次',
          realTime: '晨起后',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日3次',
          realTime: '早/中/晚餐',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每周5次',
          realTime: '每次30-45分钟',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每周2次',
          realTime: '每次20-30分钟',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日1次',
          realTime: '23:00前',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日3次',
          realTime: '早/中/晚餐',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每周5次',
          realTime: '每次30-45分钟',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每日1次',
          realTime: '每晚21:00前',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '每周2次',
          realTime: '',
          confirm: 0,
          excutor: ''
        },
        {
          measure: '',
          frequency: '',
          realTime: '预约时间',
          confirm: 0,
          excutor: ''
        },
        {
          other: '',
          measure: '',
          frequency: '',
          realTime: '',
          confirm: 0,
          excutor: ''
        }
      ],
      rateOptions: [
        {
          value: '1',
          label: '每月1次'
        },
        {
          value: '2',
          label: '每月2次'
        },
        {
          value: '3',
          label: '每月3次'
        },
        {
          value: '4',
          label: '每月4次'
        },
        {
          value: '5',
          label: '每月5次'
        }
      ],
      rateSortOptions: [
        {
          value: '1',
          label: '每日1次'
        },
        {
          value: '2',
          label: '每日2次'
        },
        {
          value: '3',
          label: '每日3次'
        },
        {
          value: '4',
          label: '每日4次'
        },
        {
          value: '5',
          label: '每4小时1次'
        },
        {
          value: '6',
          label: '疼痛时服用'
        },
        {
          value: '7',
          label: '一次性'
        }
      ],
      tableData: [],
      noMedicineData: [],
      medicineData: [],
      manageData: [],
      otherData: []
    }
  },
  mounted() {
    this.doctorOrderLong_recent = this.doctorOrderLong_model
    this.doctorOrderSort_recent = this.doctorOrderSort_model
    // this.doctorOrderDetail = this.doctorOrderLong_model;
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId

      getUserJkDetail(wxUserId).then(res => {
        this.info = res.data.userJk
        this.doctorOrder.name = res.data.userJk.name
      })

      getScheme(wxUserId).then(res => {
        this.data = res.data
      })
    },

    createDoctorOrder(index) {
      if (index === 1) {
        getLongTermDoctorOrder(this.wxUserId, this.doctorOrder.orderDate).then(res => {
          const data = res.data
          console.log(data)
          this.doctorOrder.name = data.baseInfo.name
          this.doctorOrder.number = data.baseInfo.number
          this.doctorOrder.orderDate = data.baseInfo.orderDate
          this.doctorOrder.doctor = data.baseInfo.managers

          this.doctorOrderDetail[0].measure = data.bodyMeasure.bpAndHr || '--'
          this.doctorOrderDetail[1].measure = data.bodyMeasure.bs || '--'
          this.doctorOrderDetail[2].measure = data.bodyMeasure.bmi || '--'

          this.doctorOrderDetail[3].measure = data.notDrugPlan.dietPlan || '--'
          this.doctorOrderDetail[4].measure = data.notDrugPlan.aerobic || '--'
          this.doctorOrderDetail[5].measure = data.notDrugPlan.power || '--'

          if (data.drugPlans.length >= 1) {
            this.doctorOrderDetail[7].measure = data.drugPlans[0].drugName
            this.doctorOrderDetail[7].frequency = data.drugPlans[0].medicationFrequency
            this.doctorOrderDetail[7].realTime = data.drugPlans[0].medicationTime
            this.doctorOrderDetail[7].confirm = 1
          }

          if (data.drugPlans.length >= 2) {
            this.doctorOrderDetail[8].measure = data.drugPlans[1].drugName
            this.doctorOrderDetail[8].frequency = data.drugPlans[1].medicationFrequency
            this.doctorOrderDetail[8].realTime = data.drugPlans[1].medicationTime
            this.doctorOrderDetail[8].confirm = 1
          }
        })
      }
      if (index === 2) {
        this.$message.error('功能开发中...')
      }
    },

    // 添加新行
    addRow() {
      this.tableData.push({
        id: Date.now(), // 使用时间戳作为唯一标识
        content: '',
        source: '',
        frequency: '',
        time: '',
        checked: false,
        signature: '',
        confirm: 0
      })
    },
    deleteRow(index) {
      this.tableData.splice(index, 1)
    },
    healthConfirm(index) {
      console.log(index)
      this.tableData[index].confirm = this.tableData[index].confirm === 1 ? 0 : 1
    },
    addNoMedicine() {
      this.noMedicineData.push({
        id: Date.now(), // 使用时间戳作为唯一标识
        content: '',
        source: '',
        frequency: '',
        time: '',
        checked: false,
        signature: '',
        confirm: 0
      })
    },
    deleteNoMedicine(index) {
      this.noMedicineData.splice(index, 1)
    },
    noMedicineConfirm(index) {
      this.noMedicineData[index].confirm = this.noMedicineData[index].confirm === 1 ? 0 : 1
    },
    addMedicine() {
      this.medicineData.push({
        id: Date.now(), // 使用时间戳作为唯一标识
        content: '',
        source: '',
        frequency: '',
        time: '',
        checked: false,
        signature: '',
        confirm: 0
      })
    },
    deleteMedicine(index) {
      this.medicineData.splice(index, 1)
    },
    medicineConfirm(index) {
      this.medicineData[index].confirm = this.medicineData[index].confirm === 1 ? 0 : 1
    },
    addManage() {
      this.manageData.push({
        id: Date.now(), // 使用时间戳作为唯一标识
        content: '',
        source: '',
        frequency: '',
        time: '',
        checked: false,
        signature: '',
        confirm: 0
      })
    },
    deleteManage(index) {
      this.manageData.splice(index, 1)
    },
    ManageConfirm(index) {
      this.manageData[index].confirm = this.manageData[index].confirm === 1 ? 0 : 1
    },
    addOther() {
      this.otherData.push({
        id: Date.now(), // 使用时间戳作为唯一标识
        content: '',
        source: '',
        frequency: '',
        time: '',
        checked: false,
        signature: '',
        confirm: 0
      })
    },
    deleteOther(index) {
      this.otherData.splice(index, 1)
    },
    otherConfirm(index) {
      this.otherData[index].confirm = this.otherData[index].confirm === 1 ? 0 : 1
    },
    toDrug(row) {
      const parameter = {
        wxUserId: this.$route.query.wxUserId
      }
      this.$router.push({
        path: '/healthmanagement/drugDetails',
        query: parameter
      })
    },

    toMotion(row) {
      const parameter = {
        wxUserId: row.wxUserId
      }
      this.$router.push({
        path: '/healthmanagement/motion',
        query: parameter
      })
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: '/healthmanagement/onlinehealthmanagement'
      })
    },

    click(index) {
      let path = ''
      switch (index) {
        case 0:
          path = '/healthmanagement/healthdata'
          break
        case 1:
          path = '/healthmanagement/digitalarchives'
          break
        case 2:
          path = '/healthmanagement/healthplan'
          break
        case 3:
          path = '/healthmanagement/cognitivebehavioral'
          break
        case 4:
          path = '/healthmanagement/pushmessages'
          break
      }
      const parameter = {
        wxUserId: this.wxUserid
      }
      this.$router.push({
        path: path,
        query: parameter
      })
    },

    tapChange(id) {
      console.log(this.reportType)
      if (this.reportType === 1 && id === 2) {
        this.doctorOrderLong_recent = this.doctorOrderDetail
        this.doctorOrderDetail = this.doctorOrderSort_recent
      }
      if (this.reportType === 2 && id === 1) {
        this.doctorOrderSort_recent = this.doctorOrderDetail
        this.doctorOrderDetail = this.doctorOrderLong_recent
      }
      if ((this.reportType === 3 || this.reportType === 4) && id === 1) {
        this.doctorOrderDetail = this.doctorOrderLong_recent
      }
      if ((this.reportType === 3 || this.reportType === 4) && id === 2) {
        this.doctorOrderDetail = this.doctorOrderSort_recent
      }
      this.doctorOrder = {
        name: this.info.name,
        orderDate: null,
        number: '',
        doctor: ''
      }

      this.reportType = id
    },

    archive() {
      console.log()

      const wxUserId = this.$route.query.wxUserId
      let date = this.doctorOrder.orderDate
      if (date != null) date = this.format(date)

      const orderRequest = {
        pcDoctorOrder: this.doctorOrder,
        pcDoctorOrderDetails: this.doctorOrderDetail
      }
      orderRequest.pcDoctorOrder.orderDate = date
      orderRequest.pcDoctorOrder.wxUserId = wxUserId

      if (this.reportType === 1) orderRequest.pcDoctorOrder.reportType = 1
      else if (this.reportType === 2) orderRequest.pcDoctorOrder.reportType = 2

      savePcDoctorOrder(orderRequest).then(res => {
        this.$message({ type: 'success', message: '存档成功' })
      })
    },

    checkRecord() {
      const wxUserId = this.$route.query.wxUserId
      this.drawer = true
      getDoctorOrder(wxUserId).then(res => {
        this.doctorOrders = res.data
      })
    },

    clickDoctorOrder(item) {
      if (this.reportType === 1) this.doctorOrderLong_recent = this.doctorOrderLong_model
      if (this.reportType === 2) this.doctorOrderSort_recent = this.doctorOrderSort_model

      if (item.reportType === 1) this.reportType = 3
      if (item.reportType === 2) this.reportType = 4
      getDoctorOrderDetail(item.wxUserId, item.orderId).then(res => {
        this.doctorOrder = res.data.order
        this.doctorOrderDetail = res.data.details
        console.log(res.data)
      })
    },

    clickDateDelete(item) {
      removeDoctorOrder(item.wxUserId, item.orderId).then(res => {
        this.doctorOrders = res.data
      })
    },

    format(date) {
      date = new Date(date)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    generatePDF() {
      this.showDialog = false // 关闭弹框

      let element = null
      if (this.reportType === 1) {
        element = document.getElementById('pdf-content')
      } else if (this.reportType === 2) {
        element = document.getElementById('pdf-content-sort')
      }

      const opt = {
        margin: 0,
        filename: this.reportType === 1 ? this.pdfOptions.filename : this.pdfOptions.filenameSort,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },

        // 关键：添加分页配置
        pagebreak: {
          mode: ['avoid-all', 'css', 'legacy'], // 多种分页模式
          before: '.page-break-before', // 在这些元素前分页
          after: '.page-break-after', // 在这些元素后分页
          avoid: ['tr', 'td', 'th'] // 避免分割这些元素
        }
      }
      // 添加分页样式
      this.addPageBreakStyles(element)

      html2pdf().from(element).set(opt).save()
    },
    // 添加分页样式
    addPageBreakStyles(element) {
      // 确保表格不会被分割
      const tables = element.getElementsByTagName('table')
      for (const table of tables) {
        table.style.pageBreakInside = 'avoid'
      }

      // 确保行不会被分割
      const rows = element.getElementsByTagName('tr')
      for (const row of rows) {
        row.style.pageBreakInside = 'avoid'
      }
    },
    refreshTable() {
      if (this.$refs.crud && typeof this.$refs.crud.refresh === 'function') {
        this.$refs.crud.refresh()
      } else {
        this.onLoad && this.onLoad(this.page)
      }
    },

    confirm(index) {
      this.doctorOrderDetail[index].confirm = this.doctorOrderDetail[index].confirm === 1 ? 0 : 1
    }
  }
}
</script>

<style scoped>
.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 10px;
}

.card {
  background: rgba(243, 235, 235, 0.884) 2F5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card03 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 1px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
}
/* 重置所有继承属性 */
.style-isolation {
  all: initial;
}

/* 重置内部所有元素 */
.style-isolation * {
  all: unset;
}

.tr {
  vertical-align: middle;
  display: table-row;
  vertical-align: inherit;
  unicode-bidi: isolate;
  border-color: inherit;
}

.my-dialog-class {
  display: flex;
  align-items: flex-start;
}

.prescription-container {
  /* font-family: "SimSun", "宋体", serif; */
  width: 210mm;
  height: 100%;
  padding: 0mm 10mm;
  box-sizing: border-box;
  float: left;
  font-family: Segoe UI, PingFang SC, Microsoft YaHei, sans-serif;
  border: 1px solid #000;
  line-height: 1.4;

  /* 防止PDF白条的关键属性 */
  border-collapse: separate !important;
  border-spacing: 0 !important;
  background: transparent !important;
  overflow: visible !important;
  position: relative !important;
  z-index: 1 !important;

  margin-top: 20px;
  margin-right: 20px;
}

input {
  border: 0px;
  line-height: 1.5;
  text-align: center;
}

.pdf-options {
  padding-left: 2%;
  float: left;
  width: 100mm;
  margin-top: 30px;
}

h1 {
  text-align: center;
  font-size: 24px;
  /* margin-bottom: 20px; */
  color: #0066cc;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0px;
}

.info-table td {
  border: 1px solid #000;
  padding: 1mm;
  font-size: 14px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0px;
}

.data-table td {
  border: 1px solid #000;
  padding: 1mm;
  font-size: 13px;
}

.model {
  margin-bottom: 0px;
}
.model .title {
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  color: #0066cc;
}

h2 {
  font-size: 15px;
  color: #0066cc;
  /* border-bottom: 1px solid #e0e0e0; */
  box-sizing: border-box;
}

h3 {
  font-size: 18px;
  margin: 10px 0;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;
}

ul,
ol {
  margin-left: 20px;
}

.signature {
  margin-top: 10px;
}

.signature div {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  /* text-align: right; */
}
.signature .date {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.signature .declare {
  width: 100%;
  color: red;
}
.signature .title {
  line-height: 30px;
  /* border:1px solid red; */
  height: 30px;
}
.signature .declare div {
  line-height: 25px;
}

p {
  margin-bottom: 0px;
  /* line-height: 1.7; */
}

template {
  all: initial;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 1px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
}
.custom-datepicker .el-input__inner {
  border: none;
  box-shadow: none;
  background-color: transparent;
}
.tap {
  width: 50px;
  height: 200px;
  margin-top: 20px;
}
.tap div {
  width: 40px;
  height: 120px;
  line-height: 40px;
  writing-mode: vertical-rl;
  color: #606266;
  text-align: center;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  margin-bottom: 5px;
  letter-spacing: 3px;
}
.tap .active {
  border: 1px solid #409eff;
  color: #409eff;
}
.clickDate {
  width: 80%;
  text-align: center;
  margin: 0px 0;
  padding: 10px 0;
  color: #2980b9;
  transform: skew(-15deg);
}

.clickDate:hover {
  text-decoration: underline;
  background-color: rgba(52, 152, 219, 0.1);
}

.clickDateDelete {
  width: 20%;
  text-align: center;
  margin: 0px 0;
  padding: 15px 0 0 0;
  color: #2980b9;
  font-size: 12px;
  transform: skew(-15deg);
}

.clickDateDelete:hover {
  text-decoration: underline;
  background-color: rgba(52, 152, 219, 0.1);
}
.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
.healthAdd {
  width: 100%;
  height: 30px;
  font-size: 30px;
  text-align: center;
  display: flex;
  margin-left: 45%;
  color: #bfbfbf;
}
.healthAdd div {
  width: 20px;
  height: 20px;
  line-height: 12px;
  margin: 10px;
  border-radius: 50%;
  border: 1px solid #bfbfbf;
  display: flex;
  justify-content: center;
}
.healthAdd div:last-child {
  font-size: 30px;
  border-radius: 50%;
  line-height: 12px;
}
</style>
